import React from 'react';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './OrderDetailTab.styled';
import { useSelector } from 'react-redux';

const OrderDetailTabList = ({ label, isTabActive, tabSwitch, id }) => {


    const handleTabClick = () => {
        tabSwitch(id);
    };

    const handleTabTouch = (event) => {
        event.preventDefault();
        tabSwitch(id);
    };

    const { replenishmentRequests } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const isReplenBackOrder = replenishmentRequests.filter(
        (item) => item.backOrderCount > 0
    );
    return (
        <>
            <StyledTabContentContianer
              id={`orders-orderdetail-tablist-${id}-tab-container`}
                onClick={handleTabClick}
                onTouchStart={handleTabTouch}
                isSelected={isTabActive}
                cursor={'pointer'}
                style={{
                    touchAction: 'manipulation',
                    WebkitTouchCallout: 'none',
                    WebkitUserSelect: 'none',
                }}
            >
                <TabContent
                    isPending={id === 'setAvailabilityPending' ? true : false}
                    isBatch={
                        id === 'backOrders' ||
                        (id === 'replenishmentRequests' &&
                            isReplenBackOrder?.length > 0) ||
                        id === 'setAvailabilityPending'
                            ? true
                            : false
                    }
                >
                    <TabContentFont
                        webTextAlign={
                            id === 'setAvailabilityPending' && 'center'
                        }
                        isSelected={isTabActive}
                    >
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default OrderDetailTabList;
